import { Component, inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'hh-care-acception-dialog',
  templateUrl: './hh-care-acception-dialog.component.html',
  styleUrls: ['./hh-care-acception-dialog.component.scss'],
  standalone: false
})
export class HHCareAcceptionDialogDialogComponent implements OnInit {
  careAcceptionForm: FormGroup;

  private readonly ref = inject(DynamicDialogRef);

  get acceptHhCare(): FormControl {
    return this.careAcceptionForm?.get('acceptHhCare') as FormControl;
  } 

  ngOnInit(): void {
    this.careAcceptionForm = new FormGroup({
      acceptHhCare: new FormControl(null, Validators.required),
      anticipatedDischargeDate: new FormControl(null),
    });
  }

  confirm() {
    this.ref.close(this.careAcceptionForm.value);
  }
  cancel() {
    this.ref.close();
  }
}